import jsonGraphqlExpress from './jsonGraphqlExpress';

export default jsonGraphqlExpress;



// WEBPACK FOOTER //
// ./src/node.js